// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style-module_disabled__1S_v7k5z4OFvEAJI-G3Ask"};